import {
  createContext,
  memo,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react'

import isEqual from 'react-fast-compare'

export type DropdownContext = {
  open: boolean
}

const DropdownContext = createContext<DropdownContext>(undefined)

export const DropdownProvider = memo(
  ({ open, children }: PropsWithChildren<DropdownContext>) => {
    const value = useMemo(
      () => ({
        open,
      }),
      [open],
    )

    return (
      <DropdownContext.Provider value={value}>
        {children}
      </DropdownContext.Provider>
    )
  },
  isEqual,
)

export const useDropdown = () => {
  const context = useContext(DropdownContext)
  if (context === undefined) {
    throw new Error('useDropdown must be used within a DropdownProvider')
  }
  return context
}
